module.exports = __webpack_public_path__ + "img/img-box-services-support-right.977a9921.png";